import '@vebox/etui-system';
import { Component, createElement } from 'react';
import { c as _defineProperty } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import '@vebox/etui-system-elements';
import '../Checkbox/CheckboxBase.js';
import '../Checkbox/CheckboxCircle.js';
import '../Checkbox/utils.js';
import Checkbox from '../Checkbox/Checkbox.js';

function checkSelection(props, data, type, byDefaultChecked) {
  const {
    store,
    getCheckboxPropsByItem,
    getRecordKey
  } = props || this.props;
  // type should be 'every' | 'some'
  if (type === 'every' || type === 'some') {
    return byDefaultChecked ? data[type]((item, i) => getCheckboxPropsByItem(item, i).defaultChecked) : data[type]((item, i) => store.getState().selectedRowKeys.indexOf(getRecordKey(item, i)) >= 0);
  }
  return false;
}
function getCheckState(props) {
  const {
    store,
    data
  } = props;
  let checked;
  if (!data.length) {
    checked = false;
  } else {
    checked = store.getState().selectionDirty ? checkSelection(props, data, 'every', false) : checkSelection(props, data, 'every', false) || checkSelection(props, data, 'every', true);
  }
  return checked;
}
function getIndeterminateState(props) {
  const {
    store,
    data
  } = props;
  let indeterminate;
  if (!data.length) {
    indeterminate = false;
  } else {
    indeterminate = store.getState().selectionDirty ? checkSelection(props, data, 'some', false) && !checkSelection(props, data, 'every', false) : checkSelection(props, data, 'some', false) && !checkSelection(props, data, 'every', false) || checkSelection(props, data, 'some', true) && !checkSelection(props, data, 'every', true);
  }
  return indeterminate;
}
class SelectionCheckboxAll extends Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "handleSelectAllChange", e => {
      const {
        checked
      } = e.target;
      this.props.onSelect(checked ? 'all' : 'removeAll', 0, null);
    });
    this.defaultSelections = props.hideDefaultSelections ? [] : [{
      key: 'all',
      text: 'All',
      onSelect: () => {}
    }, {
      key: 'invert',
      text: 'Invert',
      onSelect: () => {}
    }];
    this.state = {
      checked: getCheckState(props),
      indeterminate: getIndeterminateState(props)
    };
  }
  componentDidMount() {
    this.subscribe();
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setCheckState(nextProps);
  }
  componentWillUnmount() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  }
  setCheckState(props) {
    const checked = getCheckState(props);
    const indeterminate = getIndeterminateState(props);
    this.setState(prevState => {
      const newState = {};
      if (indeterminate !== prevState.indeterminate) {
        newState.indeterminate = indeterminate;
      }
      if (checked !== prevState.checked) {
        newState.checked = checked;
      }
      return newState;
    });
  }
  subscribe() {
    const {
      store
    } = this.props;
    this.unsubscribe = store.subscribe(() => {
      this.setCheckState(this.props);
    });
  }
  render() {
    const {
      disabled
    } = this.props;
    const {
      checked,
      indeterminate
    } = this.state;
    return /*#__PURE__*/createElement(Checkbox, {
      checked: checked,
      indeterminate: indeterminate,
      disabled: disabled,
      onChange: this.handleSelectAllChange
    });
  }
}

export default SelectionCheckboxAll;
